module.exports = __webpack_public_path__ + "img/notification.ba827174.svg";